import { render, staticRenderFns } from "./ApproveLevel1.vue?vue&type=template&id=1fc06aaf&scoped=true"
import script from "./ApproveLevel1.vue?vue&type=script&lang=js"
export * from "./ApproveLevel1.vue?vue&type=script&lang=js"
import style0 from "./ApproveLevel1.vue?vue&type=style&index=0&id=1fc06aaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc06aaf",
  null
  
)

export default component.exports